// @ts-nocheck
/* eslint-disable global-require */
const reactModule = (Component, nodeList) => {
    const React = require('react');
    const { createRoot } = require('react-dom');
    nodeList.forEach(node => {
        const root = createRoot(node);
        root.render(React.createElement(Component, { ...node.dataset }));
    });
};
const components = [
    {
        name: 'LogoCarousel',
        loader: () => import('./components/LogoCarousel')
    },
    {
        name: 'VideoModal',
        loader: () => import('./components/VideoModal')
    },
    {
        name: 'ShareThis',
        loader: () => import('./components/ShareThis')
    },
    {
        name: 'Modal',
        loader: () => import('./components/Modal')
    },
    {
        name: 'Tabs',
        loader: () => import('./components/Tabs')
    },
    {
        name: 'Dropdown',
        loader: () => import('./components/Dropdown')
    }
];
const modules = [
    { name: 'Header', loader: () => import('./modules/header/index') },
    {
        name: 'FullWidthCtaBanner',
        loader: () => import('./modules/FullWidthCtaBanner')
    },
    {
        name: 'PartnerLogoBanner',
        loader: () => import('./modules/PartnerLogoBanner')
    },
    {
        name: 'ContentWithMediaRow',
        loader: () => import('./modules/ContentWithMediaRow')
    },
    {
        name: 'ContentSideNavigation',
        loader: () => import('./modules/ContentSideNavigation')
    },
    {
        name: 'FilteredResourceCards',
        loader: () => import('./modules/FilteredResourceCards')
    },
    {
        name: 'IconGrid',
        loader: () => import('./modules/IconGrid')
    },
    {
        name: 'HomepageMasthead',
        loader: () => import('./modules/HomepageMasthead')
    },
    {
        name: 'FeaturedResourceCards',
        loader: () => import('./modules/FeaturedResourceCards')
    },
    {
        name: 'TestimonialsRow',
        loader: () => import('./modules/TestimonialsRow')
    },
    {
        name: 'FeaturedContentTabsRow',
        loader: () => import('./modules/FeaturedContentTabsRow')
    },
    {
        name: 'FeaturedContentTabsWithImageRow',
        loader: () => import('./modules/FeaturedContentTabsWithImageRow')
    },
    {
        name: 'MediaMasthead',
        loader: () => import('./modules/MediaMasthead')
    },
    {
        name: 'FeaturedResourceCardsWithImage',
        loader: () => import('./modules/FeaturedResourceCardsWithImage')
    },
    {
        name: 'SimpleMasthead',
        loader: () => import('./modules/SimpleMasthead')
    },
    {
        name: 'Footer',
        loader: () => import('./modules/Footer')
    },
    {
        name: 'PortalLogin',
        loader: () => import('./modules/PortalLogin')
    },
    {
        name: 'ProductCheckout',
        loader: () => import('./modules/ProductCheckout')
    },
    {
        name: 'AlertBanner',
        loader: () => import('./modules/AlertBanner')
    },
    {
        name: 'Accordion',
        loader: () => import('./modules/Accordion')
    },
    {
        name: 'SearchResultsListing',
        loader: () => import('./modules/react/SearchResultsListing/index.tsx'),
        render: reactModule
    },
    {
        name: 'DriverDownloadBlock',
        loader: () => import('./modules/react/DriverDownloadBlock'),
        render: reactModule
    },
    {
        name: 'MegaMenu',
        loader: () => import('./modules/react/MegaMenu'),
        render: reactModule
    },
    {
        name: 'ProductComparisonTable',
        loader: () => import('./modules/ProductComparisonTable')
    },
    {
        name: 'ProductComparisonTableV2',
        loader: () => import('./modules/ProductComparisonTableV2')
    },
    {
        name: 'ContactUsForm',
        loader: () => import('./modules/ContactUsForm')
    },
    {
        name: 'PopUpBanner',
        loader: () => import('./modules/PopUpBanner')
    },
    {
        name: 'MastheadForm',
        loader: () => import('./modules/MastheadForm')
    },
    {
        name: 'ContentDetailGatedForm',
        loader: () => import('./modules/ContentDetailGatedForm')
    },
    {
        name: 'TabbedBlock',
        loader: () => import('./modules/TabbedBlock')
    },
    {
        name: 'CloudStarterMasthead',
        loader: () => import('./modules/CloudStarterMasthead')
    },
    {
        name: 'GifSectionsWithMenu',
        loader: () => import('./modules/GifSectionsWithMenu')
    },
    {
        name: 'PromoBlock',
        loader: () => import('./modules/PromoBlock')
    },
    {
        name: 'HeroBlock',
        loader: () => import('./modules/HeroBlock')
    },
    {
        name: 'PromoBox',
        loader: () => import('./modules/PromoBox')
    },
    {
        name: 'FormBlock',
        loader: () => import('./modules/FormBlock')
    },
    {
        name: 'ReactRoot',
        loader: () => import('./modules/react/redesign/ReactRoot/ReactRoot.tsx'),
        render: reactModule
    }
];
export default [...components, ...modules];
